// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8d3ef2c","455":"e92ccbb0","977":"2df95dbf"}[chunkId] + ".chunk.js";
};